/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import React, { FC, ReactNode } from "react";

/**
 * Xng Picture Component
 */

interface Props {
    mediumImageSrc: string;
    smallImageSrc: string;
    largeImageSrc: string;
    altText: string;
    disableLazyLoad?: boolean;
    width?: string;
    height?: string;
}

const LazyPicture: FC<Props> = ({
    largeImageSrc,
    mediumImageSrc,
    smallImageSrc,
    altText,
    disableLazyLoad,
    width,
    height,
}) => {
    const [selectedSrc, setSelectedSrc] = React.useState(largeImageSrc);
    React.useEffect(() => {
        window.addEventListener("resize", getDimensions);
        getDimensions();
        return () => {
            window.removeEventListener("resize", getDimensions);
        };
    }, []);

    const getDimensions = () => {
        // using the id as class name selector ensures that each carousel is treated on its own width not as a group
        if (window?.innerWidth <= 768) {
            if (smallImageSrc) {
                setSelectedSrc(smallImageSrc);
            }
        } else if (window?.innerWidth <= 1024) {
            if (mediumImageSrc) {
                setSelectedSrc(mediumImageSrc);
            }
        } else if (largeImageSrc) {
            setSelectedSrc(largeImageSrc);
        }
    };

    return (
        <StyledWrapper>
            <LazyImage
                src={selectedSrc}
                altText={altText}
                width={width}
                height={height}
                {...({ disableLazyLoad } as any)}
            />
        </StyledWrapper>
    );
};

/** @component */
export default LazyPicture;
